function getVideos() {
  const videos = document.querySelectorAll('.video-placeholder__thumbnail');
  return videos;
}

function setupVideos() {
  // watch video
  const videos = getVideos();

  videos.forEach((el) => {
    el.addEventListener('click', (e) => {
      const isHosted = el.getAttribute('data-hosted') === 'true' ?? false;
      el.nextElementSibling.hidden = false;
      if (isHosted) {
        el.nextElementSibling.play();
      } else {
        el.nextElementSibling.src = el.nextElementSibling.dataset.src;
      }
      if (el.querySelector('.video-placeholder__play')) {
        el.querySelector('.video-placeholder__play').remove();
      }
      el.classList.add('video-placeholder__thumbnail--playing');
      return false;
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  setupVideos();
});
